import StockVue from '@/views/sa/stock/stock.vue';

const basePath = '/sa/stock';
const role = 'sa'; // 角色身份

export const SA_STOCK_INDEX = 'sa-stock-index';
export const SA_EDIT_STOCK = 'sa-edit-stock';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: StockVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_STOCK_INDEX,
      component: () => import(
        /* webpackChunkName: "preselect" */
        `@/views/${role}/stock/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit-stock`,
      name: SA_EDIT_STOCK,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/stock/edit-stock.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
    // {
    //   path: `${basePath}/edit-stock`,
    //   name: SA_EDIT_STOCK,
    //   props: true,
    //   component: () => import(
    //     /* webpackChunkName: "preselect" */
    //     `@/views/${role}/stock/edit-stock.vue`
    //   ).catch(() => import('@/views/errors/404.vue')),
    //   meta: { requiresAuth: true }
    // },
  ]
};
